/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { JWTToken } from '../models/tokens';

export interface IAuthService {
  isUserAuthenticated(): boolean;
  getAccessToken(): JWTToken | null;
  getAccessExp(): number | null;
  setAccessToken(token: JWTToken): void;
  setAccessExp(exp: number): void;
  removeAccessToken(): void;
}

export class AuthService implements IAuthService {
  public static ACCESS_TOKEN_NAME = 'uUiCSJPwTxHnSKXSfbaSbdeBgEDBbCef';
  public static EXPIRY_NAME = 'dsfhjkh98d8y0hdnflshldhlhjasdf';
  public accessToken: JWTToken | null;
  public exp: number | null;

  constructor() {
    this.accessToken = this.getAccessToken();
    this.exp = this.getAccessExp();
  }

  isUserAuthenticated(): boolean {
    const token = this.getAccessToken();
    const exp = this.getAccessExp();
    if (!token || !exp) {
      return false;
    }

    return !!token;
  }

  getAccessExp(): number | null {
    const exp = localStorage.getItem(AuthService.EXPIRY_NAME);
    if (!exp) return null;

    return Number(exp);
  }

  getAccessToken(): JWTToken | null {
    const token = localStorage.getItem(AuthService.ACCESS_TOKEN_NAME);
    if (!token) return null;

    return token;
  }

  setAccessExp(exp: number): void {
    localStorage.setItem(AuthService.EXPIRY_NAME, `${exp}`);
  }

  setAccessToken(token: JWTToken): void {
    localStorage.setItem(AuthService.ACCESS_TOKEN_NAME, token);
  }

  removeAccessToken(): void {
    localStorage.removeItem(AuthService.ACCESS_TOKEN_NAME);
    localStorage.removeItem(AuthService.EXPIRY_NAME);
  }
}
